<template>
    <div v-if="src" style="text-align: center;padding: 0">
        <PaperSlogan/>
        <div style="color: #EE822F;text-align: center;font-weight: 500">
            兑换码
        </div>
        <div style="font-size: 10px; color: rgba(0,0,0,0.28);text-align: right">No.{{data.no + 800000}}</div>
        <img :src="src" alt="" width="100%">
        <p style="font-size: 10px; color: rgba(0,0,0,0.28);margin-bottom: 10px; margin-top: 5px; text-align: left">
            {{data.presenter}}赠送您VIPaper会员权限，扫描此二维码注册/充值可获{{data.points}}积分。
            本二维码一次使用后自动失效，有效期至{{data.valid_end_date}}。
        </p>
    </div>

</template>
<script>

    import { defineComponent } from 'vue';
    import QRCode from 'qrcode';
    import PaperSlogan from "../../components/PaperSlogan";


    export default defineComponent({
        name: "PaperQrcode",
        components: {
            PaperSlogan
        },
        props: ['data', 'code', 'name', 'points', 'end'],
        data() {
            return {
                loading: true,
                src: ''
            };
        },
        created(){
            this.createQrCode();
        },
        methods: {
            async createQrCode(){
                this.src = await QRCode.toDataURL(window.location.origin + '/login/?code=' + this.data.coupon_code + '&points=' + this.data.points,
                    {margin: 0});
            },
        }
    });
</script>

<style scoped>

</style>
